let inputCounter = 0;
let nextNumber = 0;

/*Used to give every input a unique id*/
export const getNextInputId = function () {
	if (inputCounter > 99999)
		inputCounter = 0;

	inputCounter++;
	return `input_${inputCounter - 1}`;
}

export const getNextNumber = function () {
	if (nextNumber > 99999)
		nextNumber = 0;
	nextNumber++;
	return nextNumber - 1;
}

export function prettyNumber(num) {
	let rVal = num.toString();
	if (num < 10)
		return `0${rVal}`;
	return num;

}


export const rgbToHex = (r, g, b) => '#' + [r, g, b].map(x => {
	const hex = x.toString(16)
	return hex.length === 1 ? '0' + hex : hex
}).join('')


export function getUrlParam(key, url) {
	if (key == null)
		return;

	if (url == null)
		url = window.location;

	const urlParams = new URLSearchParams(new URL(url).search);
	let rVal = urlParams.get(key);
	if(rVal == '')
		rVal = null;
	return rVal;
}